import { render, staticRenderFns } from "./IconsCommon.vue?vue&type=template&id=47ab0595&scoped=true&"
import script from "./IconsCommon.vue?vue&type=script&lang=js&"
export * from "./IconsCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ab0595",
  null
  
)

export default component.exports